let isEnabled = false

const init = () => {
  if (window.webkit && window.webkit.messageHandlers && window.webkit && window.webkit.messageHandlers.observer) {
    isEnabled = true
  }
}

const postMessage = args => {
  if (isEnabled) {
    window.webkit.messageHandlers.observer.postMessage(args)
  }
}

export default {
  init,
  postMessage
}
